module.exports = __webpack_public_path__ + "img/englishProgression.ba6806a8.jpg";